import type { FormikConfig } from 'formik';

export interface JoinProFormValues {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}

export interface JoinProFormData {
  form: FormikConfig<JoinProFormValues>;
}

export interface JoinProFormProps extends JoinProFormData {}
